import { SVGProps } from 'react'

export type RoundCheckbox3Props = SVGProps<SVGSVGElement> & {
  circleColor?: string
  circleOpacity?: number
  checkColor?: string
}

export const RoundCheckbox3 = ({
  circleColor,
  circleOpacity,
  checkColor,
  ...props
}: RoundCheckbox3Props) => {
  return (
    <svg
      width="65"
      height="64"
      viewBox="0 0 65 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        opacity={circleOpacity || '0.2'}
        cx="32.5"
        cy="32"
        r="32"
        fill={circleColor || '#257E74'}
      />
      <g clipPath="url(#clip0_3500_33027)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.5 37.2666L22.9 31.6666L21.0333 33.5333L28.5 41L44.5 25L42.6333 23.1333L28.5 37.2666Z"
          fill={checkColor || '#257E74'}
        />
      </g>
      <defs>
        <clipPath id="clip0_3500_33027">
          <rect width="24" height="24" fill="white" transform="translate(20.5 21)" />
        </clipPath>
      </defs>
    </svg>
  )
}
